export default function (el) {
    wrapBlock(el)
}

function wrapBlock (element) {
    for(let i = 0; i < element.childNodes.length; i++) {
        let node = element.childNodes[i]
        if (node.constructor.name === 'Text') {
            wrapChar(node)
        } else if (!node.classList.contains('char')) {
            wrapBlock(node)
        }
    }
}

function wrapChar (node) {
    let text = node.nodeValue
    let fragment = document.createDocumentFragment()
    for (let i = 0; i < text.length; i++) {
        let char = text[i];
        let span = document.createElement('span')
        span.classList.add('char');
        span.innerHTML = char;
        fragment.appendChild(span);
    }
    node.parentElement.replaceChild(fragment, node);
}